import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const Alert = ({ variant = 'success', children }) => {
    const variants = {
        success: 'bg-green-50 border-green-200 text-green-800',
        error: 'bg-red-50 border-red-200 text-red-800',
        warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
        info: 'bg-blue-50 border-blue-200 text-blue-800'
    };

    return (
        <div className={`flex items-center gap-2 p-4 border rounded-lg ${variants[variant]}`}>
            {variant === 'success' && <CheckCircle2 className="h-5 w-5 text-green-600" />}
            <div className="text-sm">{children}</div>
        </div>
    );
};

export const AlertDescription = ({ children, className = '' }) => {
    return (
        <div className={`text-sm [&_p]:leading-relaxed ${className}`}>
            {children}
        </div>
    );
};